function parseWaypointId(waypointId) {
  const prefix = 'wp_';
  const delimiter = '_';
  function getFloor() {
    let floor = waypointId.slice(prefix.length);
    floor = floor.slice(0, floor.indexOf(delimiter));
    return parseInt(floor);
  }

  return {
    getFloor,
  };
}


export default parseWaypointId;